import { Reveal, ChapterLabel } from "@/components/site/Reveal";
import { HELP_SIGNS } from "@/lib/content";
import { Heart } from "lucide-react";

export default function WannHilfe() {
  return (
    <section
      id="hilfe-noetig"
      data-testid="section-wann-hilfe"
      className="relative py-20 md:py-32"
    >
      <div className="max-w-6xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
        <div className="lg:col-span-5 lg:sticky lg:top-28">
          <ChapterLabel index={1} label="Wann soll ich handeln?" color="text-brand-orange" />
          <Reveal className="mt-6">
            <h2 className="font-heading font-bold text-ink text-3xl md:text-4xl lg:text-5xl tracking-tight text-balance">
              Achte auf diese Anzeichen
            </h2>
            <p className="mt-5 text-lg md:text-xl leading-relaxed text-ink-muted">
              Zeigt ein Igel eines dieser Warnsignale, braucht er wahrscheinlich
              Hilfe. Im Zweifel melde dich einfach kurz bei mir – lieber einmal
              zu viel als zu wenig.
            </p>
          </Reveal>
        </div>

        <div className="lg:col-span-7">
          <ul className="space-y-4">
            {HELP_SIGNS.map((sign, i) => (
              <Reveal
                as="li"
                key={i}
                delay={i * 0.06}
                data-testid={`help-sign-${i + 1}`}
                className="flex items-start gap-4 rounded-2xl bg-white p-5 md:p-6 shadow-soft border border-ink/5"
              >
                <span className="mt-0.5 shrink-0 w-9 h-9 rounded-full bg-brand-pink/12 flex items-center justify-center">
                  <Heart className="w-5 h-5 text-brand-pink" fill="#E06A88" />
                </span>
                <span className="text-lg md:text-xl text-ink font-medium leading-snug">
                  {sign}
                </span>
              </Reveal>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
